/**
 * TeleportGhost - 텔레포트 placing 단계 고스트 프리뷰
 *
 * 회전된 블록을 마우스 위치에 따라 반투명으로 렌더링.
 * 유효 위치 → 초록, 무효 → 빨강, 앵커 null → 숨김.
 * 셀 단위 스냅, 인형 이미지 반투명 표시.
 */
import React from 'react'
import { Group, Rect, Image as KonvaImage } from 'react-konva'
import { CELL_SIZE, COLORS } from '../constants'
import { cellToPixel } from './Grid'

interface TeleportGhostProps {
  /** 회전 후 상대 좌표 배열 */
  ghostCells: { col: number; row: number }[]
  /** 현재 앵커 (마우스가 가리키는 셀) */
  anchor: { col: number; row: number } | null
  /** 현재 위치가 유효한지 */
  isValid: boolean
  /** 인형 이미지 (on 상태) */
  unitImage?: HTMLImageElement | null
}

export const TeleportGhost: React.FC<TeleportGhostProps> = ({
  ghostCells,
  anchor,
  isValid,
  unitImage,
}) => {
  if (!anchor || ghostCells.length === 0) return null

  const fillColor = isValid ? COLORS.teleportGhostValid : COLORS.teleportGhostInvalid
  const strokeColor = isValid ? '#43A047' : '#E53935'

  return (
    <Group listening={false} opacity={0.55}>
      {ghostCells.map(({ col, row }, i) => {
        const absCol = anchor.col + col
        const absRow = anchor.row + row
        const pos = cellToPixel(absCol, absRow)
        return (
          <React.Fragment key={`ghost-${i}`}>
            <Rect
              x={pos.x}
              y={pos.y}
              width={CELL_SIZE}
              height={CELL_SIZE}
              fill={fillColor}
              stroke={strokeColor}
              strokeWidth={2}
              cornerRadius={4}
            />
            {unitImage && (
              <KonvaImage
                x={pos.x}
                y={pos.y}
                width={CELL_SIZE}
                height={CELL_SIZE}
                image={unitImage}
                opacity={0.6}
              />
            )}
          </React.Fragment>
        )
      })}
    </Group>
  )
}
